import { configure, makeAutoObservable } from "mobx";
class RootScopeStore {
    // errCd: {},
    // panelmsg: {},
    // isErrorForPanel: false,
    // isErrorForAlert: false,
    // currentErrorMsg: null,
    // length: 0
    errors = {
    };
    currentPage = 'top';
    footer = {};
    editFlg = false;
    hiddenFlg = true;
    loading = false;
    requireDisabledFlg = true;
    pageType = null;
    kbn = {};
    kbnList = [];
    Message = {};
    MessageList = [];
    openerParams = {};
    navigate;
    modalScopes = [];
    constructor() {
        makeAutoObservable(this);
        configure({
            enforceActions: 'never',
        })
    }
    setErrors(key, value) {
        this.errors[key] = value;
    }
}


const rootScope = new RootScopeStore();

export default rootScope;
